module.exports = __webpack_public_path__ + "img/banner-30.56f1c6a1.jpg";